import * as React from "react";

const CustomEnvelopeIcon: React.FC = () => {
    return (
        <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6 7.25C5.61258 7.25 5.22516 7.12292 4.89469 6.86539L0 3.05937V8.375C0 8.99609 0.503672 9.5 1.125 9.5H10.875C11.4963 9.5 12 8.99633 12 8.375V3.05937L7.10625 6.86797C6.77578 7.12344 6.38672 7.25 6 7.25ZM0.381797 2.40547L5.35523 6.275C5.73469 6.57031 6.26625 6.57031 6.6457 6.275L11.6191 2.40547C11.8383 2.21797 12 1.92969 12 1.625C12 1.00367 11.4961 0.5 10.875 0.5H1.125C0.503672 0.5 0 1.00367 0 1.625C0 1.92969 0.140859 2.21797 0.381797 2.40547Z"
                fill="#0F96D9"
            />
        </svg>
    );
};

export default React.memo(CustomEnvelopeIcon);
